import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { SuspendedVehiclesPage } from "@/features/vehicles/pages/suspended-vehicles-page";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicles/suspended"
)({
	head: () => pageTitle("Suspended vehicles"),
	component: SuspendedVehiclesPage,
});
